<template>
  <div>
    <!-- head -->
    <div class="row">
      <div class="col-md-6">
        <h4 class="text-bold">Update Payment Status</h4>
        <h3 class="text-bold" v-if="order !== null">
          Order No #{{ _formatOrderId(order.id) }}
        </h3>
      </div>
      <div class="col-md-6 text-right">
        <h5 class="text-bold">
          Order Status:
          <label class="label label-primary">{{ order.payment_status }}</label>
        </h5>
      </div>
    </div>
    <!-- head -->
    <!-- table -->
    <div class="row mt-10">
      <div class="col-md-12">
        <div class="grid simple white shadow">
          <div class="grid-body">
            <table class="table table-condensed" v-if="notifications !== null">
              <thead>
                <tr>
                  <th style="width: 2%"></th>
                  <th style="width: 10%">Requested Date</th>
                  <th style="width: 10%">Requested By</th>
                  <th style="width: 10%">Amount</th>
                  <th style="width: 10%">Type</th>
                  <th style="width: 10%">Due By</th>
                  <th style="width: 10%">Handled Date</th>
                  <th style="width: 10%"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="notification in notifications">
                  <td>
                    <i
                      class="fa fa-2x fa-check-circle"
                      v-if="notification.handled_date !== null"
                    ></i>
                    <i
                      class="fa fa-2x fa-circle-o"
                      v-if="notification.handled_date === null"
                    ></i>
                  </td>
                  <td>{{ _formatDate(notification.requested_date) }}</td>
                  <td>{{ notification.requested_by }}</td>
                  <td>
                    {{ _formatCurrency(notification.amount) }}
                    {{ notification.currency }}
                  </td>
                  <td>{{ notification.type }}</td>
                  <td>{{ _formatDate(notification.due_date) }}</td>
                  <td>
                    {{
                      notification.handled_date !== null
                        ? _formatDate(notification.handled_date)
                        : "-"
                    }}
                  </td>
                  <td>
                    <button
                      class="btn btn-default disabled"
                      v-if="notification.handled_date !== null"
                    >
                      Mark Payment Made
                    </button>
                    <button
                      @click="handlePaymentNotification(notification.id)"
                      class="btn btn-primary"
                      v-if="notification.handled_date === null"
                    >
                      Mark Payment Made
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- table -->
  </div>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      order: null,
      notifications: null,
    };
  },
  mounted() {
    let orderId = this.$route.params.order_id;
    this.getNotifications(orderId);
  },
  methods: {
    _formatOrderId(orderId) {
      if (orderId <= 99999) {
        orderId = ("0000" + orderId).slice(-5);
      }
      return orderId;
    },
    _formatDate(date) {
      var m = moment(date, "YYYY-MM-DD");
      return m.isValid()
        ? moment(date, "YYYY-MM-DD").format("DD-MMM-YYYY")
        : "N/A";
    },
    _formatCurrency(amount) {
      return amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
    },
    async getNotifications(orderId) {
      try {
        let results = await axios({
          method: "get",
          url: "/fabrics/payment_notifications/" + orderId,
        });
        this.order = results.data.order;
        this.notifications = results.data.notifications;
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          toastr.error(
            "There was some errors, please correct and try again, or contact the admins"
          );
        }
      }
    },
    async handlePaymentNotification(notificationId) {
      try {
        let results = await axios({
          method: "post",
          url: "/fabrics/payment_notifications/" + notificationId + "/handle",
        });
        this.getNotifications(this.order.id);
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          toastr.error(
            "There was some errors, please correct and try again, or contact the admins"
          );
        }
      }
    },
  },
};
</script>

<style scoped>
</style>
